import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, roles }) {
    const { user } = useAuth();
    if (user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-50">
                <Loader2 className="w-6 h-6 animate-spin text-slate-500" />
            </div>
        );
    }
    if (user === false) return <Navigate to="/login" replace />;
    if (roles && roles.length && user.role !== "super_admin" && !roles.includes(user.role)) {
        return (
            <div className="p-8 text-slate-600" data-testid="access-denied">
                <h2 className="text-xl font-semibold">Access denied</h2>
                <p className="mt-2 text-sm">Your role ({user.role}) does not have access to this page.</p>
            </div>
        );
    }
    return children;
}
